<template>
  <DashboardWidgetLineSmooth class="widget-cash-flow-line" title="Cash Flow" :dataY="dataY" :dataX="dataX" legend="Cash Flow" />
</template>

<script>

export default {
  name: 'dashboard-widget-cash-flow-line',
  components: {
    DashboardWidgetLineSmooth: () => import('../BaseWidgets/DashboardWidgetLineSmooth'),
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    dataY () {
      return this.values.map(v => {
        return v.value;
      });
    },
    dataX () {
      return this.values.map(v => {
        return v.date;
      });
    },
  },
};

</script>
